<template>
  <div :class="$route.name + '-page'">
    <Header></Header>
    <div class="content_template">
      <a-config-provider :locale="zh_CN">
        <router-view v-if="RouterShow"></router-view>
      </a-config-provider>
    </div>
    <el-backtop target="#app"></el-backtop>
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import Header from "./Header";
import Footer from "./Footer";
import { myMixin } from "@/mixins/tool.js";

export default {
  name: "pc",
  components: {
    Header,
    Footer,
  },
  mixins: [myMixin],
};
</script>
<style lang="less"></style>
<style>
.content_template {
  width: 100%;
  margin: 0px auto;
  /* min-height: 800px; */
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/index.vue